import styled from "styled-components";
import Button from "./Button";
import {
    PortalActionBar,
    PortalCaption,
    PortalMetricCard,
    PortalPanelHeader,
    PortalSectionTitle,
    portalColors
} from "./BusinessPortalComponents";

export const CustomiseStepShell = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: ${p => p.$compact ? "1.25rem" : "2rem"};
    width: 100%;
`;

export const CustomiseStepContent = styled.div`
    flex: 1 1 ${p => p.$compact ? "420px" : "500px"};
    min-width: 300px;
    max-width: ${p => p.$compact ? "520px" : "none"};
    display: grid;
    gap: 0.85rem;
    align-content: start;
`;

export const CustomiseStepHeader = styled(PortalPanelHeader).attrs({ withDivider: true })``;

export const CustomiseStepTitle = PortalSectionTitle;

export const CustomiseStepCaption = PortalCaption;

export const CustomiseStepCard = styled(PortalMetricCard)`
    min-height: auto;
    align-content: start;
    padding: ${p => p.padding || "0.9rem"};
`;

export const CustomiseStepCardTitle = styled.div`
    color: ${portalColors.text};
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.875rem;
    font-weight: 800;
    line-height: 1.35;
    margin: 0;
`;

export const CustomiseStepFieldGrid = styled.div`
    display: grid;
    grid-template-columns: ${p => p.columns || "repeat(3, minmax(0, 1fr))"};
    gap: ${p => p.gap || "0.85rem"};

    @media (max-width: 760px) {
        grid-template-columns: 1fr;
    }
`;

export const CustomiseStepField = styled.div`
    min-width: 0;
    display: grid;
    gap: 0.5rem;
`;

export const CustomiseStepDivider = styled.div`
    width: 100%;
    height: 1px;
    background: ${portalColors.border};
`;

export const CustomiseStepActions = styled(PortalActionBar)`
    padding: 1rem 0 0;
    border: transparent;
    box-shadow: none;
    border-radius: 0;
    justify-content: flex-start;
`;

export const CustomiseStepButton = styled(Button)`
    width: ${p => p.width || "8.75rem"};
    min-width: ${p => p.minWidth || "8.75rem"};
    height: ${p => p.height || "2.625rem"};
    min-height: ${p => p.minHeight || "2.625rem"};
    color: ${p => p.color || (p.$variant === "primary" ? "var(--calendar-bg, #FFFFFF)" : portalColors.text)};
    background-color: ${p => p.backgroundColor || (p.$variant === "primary" ? portalColors.text : portalColors.surface)};
    border: ${p => p.border || `1px solid ${p.$variant === "primary" ? portalColors.text : portalColors.border}`};
    border-radius: var(--calendar-radius-control, 8px) !important;
    line-height: 100%;
    font-weight: 700;
    font-size: 0.875rem;
`;
